import State, { StateCodes } from '../enums/State';

export const getAllowedStates = (allowedStateCodes: StateCodes[]) => {
  return Object.keys(State)
    .filter((state: string) => {
      return allowedStateCodes.indexOf(state as any) >= 0;
    })
    .map((state: string) => {
      // @ts-ignore
      return { value: state as string, label: State[state] };
    });
};

export const getAllowedStatesFromJson = () => {
  return Object.keys(StateCodes).map((state: string) => {
    // @ts-ignore
    return { value: state as string, label: State[state] };
  });
};

export const getAllowedStatesCodesFromJson = () => {
  return Object.keys(StateCodes).map((state: string) => {
    // @ts-ignore
    return { value: state as string, label: StateCodes[state] };
  });
};

export const getStateFullNameByCode = (stateCode: string): string => {
  // @ts-ignore
  return State[stateCode] ? State[stateCode] : '';
};

export const getAllNotAllowedStatesCodes = (allowedStateCodes: StateCodes[]) => {
  return Object.keys(State)
    .filter((state: string) => {
      return allowedStateCodes.indexOf(state as any) < 0;
    })
    .map((state: string) => {
      // @ts-ignore
      return { value: state as string, label: State[state] };
    });
};
